// extracted by mini-css-extract-plugin
export default {"empty_message":"TestsTaken_empty_message__0Wry-"};